/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Editor_Ingredient_NInputs */

const en_editor_ingredient_n = /** @type {(inputs: Editor_Ingredient_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ingredient ${i?.n}`)
};

const de_editor_ingredient_n = /** @type {(inputs: Editor_Ingredient_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zutat ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Ingredient {n}" |
*
* @param {Editor_Ingredient_NInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredient_n = /** @type {((inputs: Editor_Ingredient_NInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredient_NInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredient_n(inputs)
	return en_editor_ingredient_n(inputs)
});